export default __webpack_public_path__ + "static/media/homepage-tom-barrett-unsplash.ab56d684.jpg";